import { DateHelper } from "@bryntum/schedulerpro";
import {WIDGET_KEYS} from "../WidgetKeys.jsx";
import {
  commentsCounColumn,
  defaultGroupRenderer as groupRenderer,
  EntityMainNameDefault,
  imagesCountColumn,
  lineThroughRenderer
} from "../../utils/utils.jsx";
import { generateMultiFilterConfigFromModel } from "../../utils/utils.jsx";
import { Checklist } from "../../../bryntum-lib/models/Checklist.tsx";
import { GRID_FIELDS_TO_OPEN_EDITOR, ICON_COL_DEF_WIDTH } from "../OtherKeys.jsx";

const CHECK_LIST_VIEW_COLUMNS_DATA = [
  { id: "checklist-record-entity", field: "asEntityType", text: "Entity", editor: false, groupRenderer, width: "10em" },
  {
    id: "checklist-record-entity-name",
    type: WIDGET_KEYS.swivuSortColumn,
    field: GRID_FIELDS_TO_OPEN_EDITOR.ENTITY_NAME,
    text: "Entity Name",
    editor: false,
    renderer: ({ value, record }) => EntityMainNameDefault(lineThroughRenderer(value, record.archived)),
    groupRenderer,
  },
  {
    id: "checklist-record-title",
    field: "title",
    type: WIDGET_KEYS.swivuSortColumn,
    text: "Checklist Title",
    width: "25.6em",
    editor: false,
    renderer: ({ value, record }) => EntityMainNameDefault(lineThroughRenderer(value, record.archived)),
    groupRenderer,
  },
  {
    id: "can-edit",
    field: "canEdit",
    text: "Can Edit",
    type: WIDGET_KEYS.swivuNoteChangeRoleColumn,
    finalizeCellEdit: ({ value, record }) => {
      if (value > record.canView) {
        record.canView = value;
      }
      return true;
    }
  },
  {
    id: "can-view",
    field: "canView",
    text: "Can View",
    type: WIDGET_KEYS.swivuNoteChangeRoleColumn,
    finalizeCellEdit: ({ value, record }) => {
      if (value < record.canEdit) {
        return "View permission cannot be higher than Edit permission"
      }
      return true;
    }
  },
  {
    id: "checklist-record-assigned-users",
    type: WIDGET_KEYS.assignToColumn,
    swivuListTitle: "Checklist Assigned To",
  },
  imagesCountColumn("imageItemsCount"),
  commentsCounColumn("commentItemsCount"),
  {
    id: "checked",
    field: "uncheckedItemsCount",
    text: "Checked",
    editor: false,
    minWidth: ICON_COL_DEF_WIDTH,
    flex: 1,
    renderer: ({ value, record }) =>  {
      if (record.isGroupHeader) return;
      const style = { color: !value ? "#0a88e9" : "#dc7f00" };
      return {
        tag: "span",
        text: value ? `${value} Left` : "All Checked",
        style
      }
    },
    groupRenderer({ groupRowFor: value }) {
      const style = {  color: !value ? "#0a88e9" : "#dc7f00" };
      return {
        text: value ? `${value} Left` : "All Checked",
        style
      }
    },
  },
  { id: "nudged", text: "Nudged", editor: false, field: "nudgeDate", flex: 1, groupRenderer },
  {
    id: "checklist-record-last-activity",
    type: "date",
    field: "updatedAt",
    text: "Last activity",
    editor: false,
    flex: 1,
    format: "MM/DD/YYYY",
    groupRenderer(e) {
      const value = e.groupRowFor;
      const formatted = value instanceof Date ? DateHelper.format(value, "MM/DD/YYYY") : value;
      return groupRenderer({ ...e, groupRowFor: formatted });
    },
  },
  { id: "aging", field: "aging", text: "Age", type: "agingColumn", editor: false, width: "13.8em" },
]

export default CHECK_LIST_VIEW_COLUMNS_DATA;

export const CHECKLIST_VIEW_FILTER_FIELD_CONFIG = {
  ...generateMultiFilterConfigFromModel(Checklist),
  asEntityType: { type: "string" },
  entityName: { type: "string" },
  assignedBoardUserValues: { type: '_swivu_settings' },
  updatedAt: { type: "date", title: "Last activity" },
};
